// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tLcgj","switchIcon":"styles_switchIcon__Aq7Ov","switchIcon_compact":"styles_switchIcon_compact__PLHFo"};